import {
	apiClient,
	getAuthHeaders,
	handleServiceError,
} from 'api/config/config';

// Transaction Services
export const transactionService = {
	// --- CRUD --- //
	getAll: async (token) => {
		try {
			return await apiClient.post(
				'client/api/v1/transaction/list',
				{
					options: {
						paginate: 100,
						sort: { createdAt: -1 },
						where: { isActive: true },
					},
					isCountOnly: false,
				},
				getAuthHeaders(token)
			);
		} catch (error) {
			handleServiceError(error);
		}
	},

	// --- STRIKE QUOTES --- //
	submitAutomatic: async (token, lnAddress, amount) => {
		try {
			return await apiClient.post(
				'client/api/v1/transaction/strikeCreateQuote',
				{ lnAddress, amount },
				getAuthHeaders(token)
			);
		} catch (error) {
			handleServiceError(error);
		}
	},
	submitInvoice: async (token, lnInvoice) => {
		try {
			return await apiClient.post(
				'client/api/v1/transaction/strikeCreateQuote',
				{ lnInvoice },
				getAuthHeaders(token)
			);
		} catch (error) {
			handleServiceError(error);
		}
	},
};
